<template>
  <div class="modal-sidebar-wrapper">
    <div class="modal-sidebar">
      <div class="modal-sidebar-header">
        <p>{{ $t('template_editor.template_editor') }}</p>
        <span title="Close Template" class="close-modal" @click="$emit('closeTemplateSidebar')">
          <i class="icon icon-close"></i>
        </span>

        <span class="hide-sidebar" @click="$emit('closeTemplateSidebar')">
          <i class="icon icon-arrow-right"></i>
        </span>

        <ul class="sidebar-template-tabs">
          <li :class="{ 'active': parentSidebarTab === 'setup' }" @click="parentSidebarTab = 'setup'; childSidebarTab = 'document'">{{ $t('template_editor.sidebar_tabs.setup') }}</li>
          <li :class="{ 'active': parentSidebarTab === 'content' }" @click="parentSidebarTab = 'content'">{{ $t('template_editor.sidebar_tabs.content') }}</li>
          <li :class="{ 'active': parentSidebarTab === 'modules' }" @click="parentSidebarTab = 'modules'">{{ $t('template_editor.sidebar_tabs.modules') }}</li>
        </ul>
      </div>

      <div class="modal-sidebar-body">
        <div v-if="parentSidebarTab === 'content'">
          <p class="modal-sidebar-header-text">{{ $t('template_editor.content') }}</p>
          <ul class="content-blocks">
            <draggable :list="partsList" :options="{ group: { name: 'omega', pull: 'clone', put: false }, sort: false }" :clone="cloneNewPart">
              <li v-for="part in partsList" class="part-list-button" :key="part.id" @click="addPartToDocument(part)">
                <span>
                  <i class="icon" :class="part.icon"></i>
                  {{ part.title }}
                </span>
                <div class="document-drag-zone">{{ $t('template_editor.drop_content_here') }}</div>
              </li>
            </draggable>
          </ul>
        </div>

        <div v-if="parentSidebarTab === 'modules'">
          <p class="modal-sidebar-header-text">{{ $t('template_editor.modules') }}</p>

          <div class="no-modules" v-if="modulesList !== false && modulesList.length <= 0">
            <img src="/images/sad.png">
            <p>{{ $t('proposal_editor_modal.no_modules') }}</p>
          </div>

          <ul class="content-blocks">
            <draggable :list="modulesList" :options="{ group: { name: 'omega', pull: 'clone', put: false }, sort: false }" :clone="cloneNewModule">
              <li v-for="module in modulesList" class="part-list-button" :key="module.id" @click="addModuleToDocument(module)">
                <span>
                  {{ module.title }}
                </span>
                <div class="document-drag-zone">{{ $t('template_editor.drop_content_here') }}</div>
              </li>
            </draggable>
          </ul>
        </div>

        <div v-if="parentSidebarTab === 'setup'">
          <ul class="sidebar-template-subtabs">
            <li @click="childSidebarTab = 'document'" :class="{ 'active': childSidebarTab === 'document' }">{{ $t('template_editor.document') }}</li>
          </ul>

          <div v-if="childSidebarTab === 'document'">
            <p class="modal-sidebar-header-text">{{ $t('template_editor.cover_layout') }}</p>
            <ul class="cover-layout-options">
              <li :class="{ 'active': payload.cover.layout === 1 || !payload.cover.layout }">
                <a @click="$set(payload.cover, 'layout', 1)"><i class="icon icon-layout-1"></i></a>
              </li>
              <li :class="{ 'active': payload.cover.layout === 2 }">
                <a @click="$set(payload.cover, 'layout', 2)"><i class="icon icon-layout-2"></i></a>
              </li>
              <li :class="{ 'active': payload.cover.layout === 3 }">
                <a @click="$set(payload.cover, 'layout', 3)"><i class="icon icon-layout-3"></i></a>
              </li>
              <li :class="{ 'active': payload.cover.layout === 4 }">
                <a @click="$set(payload.cover, 'layout', 4)"><i class="icon icon-layout-4"></i></a>
              </li>
            </ul>

            <p class="modal-sidebar-header-text">{{ $t('template_editor.cover_background') }}</p>
            <ul class="cover-background-options">
              <li
                @click="$set(payload.cover, 'themeName', 'blank'); payload.cover.backgroundImage = null; payload.cover.backgroundColor = '#ffffff'; payload.cover.color = '#000000';"
                :class="{ 'active': !payload.cover.backgroundImage && payload.cover.backgroundColor === '#ffffff' && payload.cover.color === '#000000' }">
                Blank
              </li>
              <li
                @click="$set(payload.cover, 'themeName', 'image'); payload.cover.backgroundColor = null; payload.cover.backgroundImage = '/images/doc-placeholder.jpg';payload.cover.color = '#FFFFFF';"
                :class="{ 'active': payload.cover.backgroundImage }">
                Image
              </li>
              <li
                @click="payload.cover.backgroundImage = null; payload.cover.backgroundColor = themes[0].backgroundColor; payload.cover.color = themes[0].color;"
                :class="{ 'active': payload.cover.backgroundColor && payload.cover.backgroundColor !== '#ffffff' }">
                Color
              </li>
            </ul>

            <div v-show="payload.cover.backgroundImage">
              <p class="modal-sidebar-subheader-text">{{ $t('template_editor.background_image') }} <span>{{ $t('template_editor.recommended_size') }}</span></p>
              <dropzone @upload="updateCoverBackgroundImage"></dropzone>
            </div>

            <div v-show="payload.cover.backgroundColor">
              <p class="modal-sidebar-subheader-text">{{ $t('template_editor.color_theme') }}</p>
              <ul class="cover-bg-color">
                <li :class="{ 'selected': isCoverThemeSelected(theme) }" @click="changeCoverTheme(theme)" v-for="theme in themes">
                  <span :style="{ 'background-color': theme.backgroundColor, 'color': theme.color }">a</span>
                </li>
              </ul>
            </div>

            <p class="modal-sidebar-header-text">{{ $t('template_editor.cover_alignment') }}</p>
            <ul class="cover-alignment-options">
              <li :class="{ 'active': payload.cover.alignment === 'left' }">
                <i class="icon icon-align-left" @click="$set(payload.cover, 'alignment', 'left')"></i>
              </li>
              <li :class="{ 'active': !payload.cover.alignment || payload.cover.alignment === 'center' }">
                <i class="icon icon-align-center" @click="$set(payload.cover, 'alignment', 'center')"></i>
              </li>
            </ul>

            <p class="modal-sidebar-header-text">{{ $t('template_editor.document_font') }}</p>
            <div class="font-options">
              <multiselect
                v-model="payload.options.documentFont"
                :options="documentFontOptions"
                :searchable="false"
                :showLabels="false"
              ></multiselect>
            </div>

            <p class="modal-sidebar-header-text">{{ $t('template_editor.paper_size') }}</p>
            <ul class="paper-size-options">
              <li
                :class="{ 'active': payload.options.paperSize === 'a4' }"
                @click="payload.options.paperSize = 'a4'">A4</li>
              <li
                :class="{ 'active': !payload.options.paperSize || payload.options.paperSize === 'letter' }"
                @click="payload.options.paperSize = 'letter'">Letter</li>
            </ul>
          </div>
        </div>

      </div>

      <div class="modal-sidebar-footer">
        <span class="actions" slot="sidebar-footer">
          <a class="button is-primary is-large" @click="$emit('save')">{{ $t('template_editor.save_template') }}</a>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
  import API from 'mixins/api';
  import DocumentSidebar from 'mixins/document-sidebar';

  export default {
    props: ['payload'],
    mixins: [API, DocumentSidebar],
    data() {
      return {
        parentSidebarTab: 'setup',
        childSidebarTab: 'document',
        showAutosave: false,
        modulesList: [],
        themes: require('settings/themeColors'),
        documentFontOptions: require('settings/documentFontOptions'),
        partsList: require('settings/documentPartsList'),
      }
    },
    beforeMount() {
      if (!this.payload.options || !this.payload.options.documentFont) {
        this.payload.options = this.payload.options ? this.payload.options : {};
        this.payload.options.documentFont = 'Helvetica';
      }

      this.api().fetchTeamModules().then(modules => {
        this.modulesList = modules;
      });
    }
  }
</script>

<style lang="scss" scoped>
  @import "resources/assets/sass/layout/_variables";
  @import "resources/assets/sass/partial/document-sidebar";
</style>



// WEBPACK FOOTER //
// template-editor-sidebar.vue?352ea6fd